import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import useCustomer from '~/features/commerce-api/hooks/useCustomer';
import { useLoginDrawer } from '~/features/login/hooks';
import { LoginDrawerMode } from '~/features/login/hooks/useLoginDrawerState';
import { LoginDrawer as LoginDrawerComponent } from '~/features/login/Login';
import { useFrame } from '~/shared/utils';
export const Shared = () => {
    const router = useRouter();
    const { isLoginDrawerOpen, close, loginDrawerMode, setLoginDrawerMode, setIsLoginDrawerOpen } =
        useLoginDrawer();

    const { isGuest, isInitialized } = useCustomer();
    const { data: frame } = useFrame();
    const { resettoken, createlogin, resetpassword, basketid } = router.query;

    const openDrawerHandler = (mode: LoginDrawerMode) => {
        setLoginDrawerMode(mode);
        setIsLoginDrawerOpen(true);
    };

    useEffect(() => {
        if (!isInitialized) return;

        if (resettoken) {
            openDrawerHandler(LoginDrawerMode.FORGOT_PASSWORD_SET_NEW);
            return;
        }

        if (createlogin !== undefined) {
            openDrawerHandler(LoginDrawerMode.CREATE_LOGIN);
            return;
        }

        if (resetpassword) {
            openDrawerHandler(LoginDrawerMode.CHANGE_PASSWORD);
            return;
        }

        if (basketid) {
            if (!isGuest) {
                router.push(frame.settings?.pageReferences.basketPage?.url ?? '/');
            } else {
                openDrawerHandler(LoginDrawerMode.LOGIN);
            }
        }
    }, [resettoken, createlogin, resetpassword, basketid, isInitialized]);

    return (
        <>
            <LoginDrawerComponent
                open={isLoginDrawerOpen}
                close={close}
                loginDrawerMode={loginDrawerMode}
                setLoginDrawerMode={setLoginDrawerMode}
            />
        </>
    );
};

export default Shared;
